import { render } from "./MedialibraryFormField.vue?vue&type=template&id=cd3b3d66"
import script from "./MedialibraryFormField.vue?vue&type=script&lang=js"
export * from "./MedialibraryFormField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/theimer/Developer/laravel/nova-medialibrary-field/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__